export default  function Error404() {
    return (<h5>You have to create new page</h5>)
  }